import { useContext } from 'react';
import styles from './SearchBarSpecialtySelect.module.scss';
// import { getCategoriesToMap } from '../../../lib/util';
import { AppContext } from '../../../context/AppContext';
import { IAppContext } from '../../../context/DefaultAppState';
import { DirectoryListType } from '../../directory-list/DirectoryList';
import * as _ from 'lodash';

const SearchBarSpecialtySelect = () => {
  const appContext = useContext(AppContext);
  // const [specialty, setSpecialty] = useState('');
  const categories = mapCategoriesByDirectory(appContext);

  return (
    <div className={styles.specialtySelectContainer}>
      <select
        className={styles.specialtySelect}
        value={appContext.chosenSpecialty}
        onChange={(e) => {
          // setSpecialty(e.target.value);
          appContext.updateChosenSpecialty(e.target.value);
        }}
      >
        {categories.map((spec) => {
          return (
            <option key={`sbsso-${spec}`} value={spec}>
              {spec}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export const mapCategoriesByDirectory = (appContext: IAppContext): string[] => {
  let specialties: string[];

  switch (appContext.directoryListType) {
    case DirectoryListType.doctor:
      specialties = _.sortBy(
        _.uniqBy(appContext.doctorSpecialties, 'specialtyName').map((ds) => _.startCase(ds.specialtyName.toLowerCase())),
        (x: any) => x.toLowerCase()
      );
      break;
    case DirectoryListType.pharmacy:
      specialties = _.sortBy(
        _.uniq(appContext.pharmacySpecialties).map((ps) => _.startCase(ps.toLowerCase())),
        (x: any) => x.toLowerCase()
      );
      break;
    case DirectoryListType.facility:
      specialties = _.sortedUniqBy(
        _.uniqBy(appContext.facilitySpecialties, 'specialtyName').map((fs) => _.startCase(fs.specialtyName.toLowerCase())),
        (x: any) => x.toLowerCase()
      );
      break;
    case DirectoryListType.dentist:
      specialties = _.sortedUniqBy(
        _.uniqBy(appContext.dentistSpecialties, 'specialtyName').map((fs) => _.startCase(fs.specialtyName.toLowerCase())),
        (x: any) => x.toLowerCase()
      );
      break;
    case DirectoryListType.all:
      const doctorSpecialties = appContext.doctorSpecialties || [];
      const pharmacySpecialties = appContext.pharmacySpecialties ? appContext.pharmacySpecialties.map((ps) => ({ specialtyName: ps })) : [];
      const facilitySpecialties = appContext.facilitySpecialties || [];
      const dentistSpecialties = appContext.dentistSpecialties || [];
      specialties = _.sortBy(
        _.uniqBy([...doctorSpecialties, ...facilitySpecialties, ...pharmacySpecialties, ...dentistSpecialties], 'specialtyName').map((s) => _.startCase(s.specialtyName.toLowerCase())),
        (x: any) => x.toLowerCase()
      );
      break;
    default:
      specialties = [];
      break;
  }

  specialties.unshift('All Specialties');
  return specialties;
};

export default SearchBarSpecialtySelect;
